import { useState } from "react";
import { Button, Dialog } from "@hybrid-iptv/ui";
import { useInstallPrompt } from "../pwa/install.js";

/**
 * "Install to device" button (roadmap §6 step 4). On Chromium it triggers the
 * deferred beforeinstallprompt; on iOS Safari it shows Add-to-Home-Screen
 * guidance instead. Hides automatically once installed/standalone.
 */
export function InstallButton() {
  const { canInstall, needsIosGuidance, promptInstall } = useInstallPrompt();
  const [showIos, setShowIos] = useState(false);

  if (!canInstall && !needsIosGuidance) return null;

  return (
    <>
      <Button
        variant="ghost"
        className="topbar__install"
        onClick={() => {
          if (needsIosGuidance) setShowIos(true);
          else void promptInstall();
        }}
        title="Install app"
      >
        ⬇ Install app
      </Button>
      <Dialog open={showIos} title="Install on iPhone / iPad" onClose={() => setShowIos(false)}>
        <p>
          Tap the <strong>Share</strong> button in Safari, then choose{" "}
          <strong>Add to Home Screen</strong>. SliqueTV will appear on your home screen like a
          native app.
        </p>
      </Dialog>
    </>
  );
}
